import React from 'react';
import {
  ChakraProvider,
  extendTheme
} from '@chakra-ui/react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './components/HomePage'
import NotAllowed from './components/NotAllowed'

const theme = extendTheme({
  colors: {
    brand: {
      100: "#59595A",
      900: "#C02033",
    },
  },
  components: {
    Radio: {
      parts: ['label'],
      baseStyle: {
        label: {
          _checked: {
            fontWeight: 'bold'
          }
        },
      },
    },
    Select: {
      baseStyle: {
        field: {
          fontWeight: 'bold'
        },
        icon: {
          // base styles for the icon go here
        }
      },
    }
  }
})

const App = () => {
  const wipProtectionToken = '7089a51f-5fab-4918-9745-2bc657d4c518';
  return (
    <ChakraProvider theme={theme}>
      <Router>
        <Routes>
          <Route path={`/${wipProtectionToken}`} element={ <HomePage/> } />
          <Route path="*" element={ <NotAllowed/> } />
        </Routes>
      </Router>
    </ChakraProvider>
  );
}

export default App;
